import { formatPrice } from '@ecom/helper-utils';

export const MembershipPrices: Record<string, number> = {
  USD: 7.99,
  MXN: 149,
  INR: 499,
  GBP: 6.99,
  EUR: 7.99,
  CAD: 10.99,
  BRL: 25.99,
  AUD: 9.99,
  NZD: 11.49,
  KRW: 8900,
  HKD: 60,
  SGD: 11,
};

export const getMembershipPrice = (currency: string, locale: string) => {
  const price = MembershipPrices[currency] ? MembershipPrices[currency] : 7.99;
  return formatPrice(price, currency, locale);
};
